export const SET_BAF_TO_FALSE = 'SET_BAF_TO_FALSE';
export const SET_BAF_TO_TRUE = 'SET_BAF_TO_TRUE';
